import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=1ac6640a&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=1ac6640a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6640a",
  null
  
)

export default component.exports